module.exports = __webpack_public_path__ + "img/fingerprint-five.2b6f74e0.svg";